import { executeRequest, JFSRequest } from '@jfs/network'
import { jsonToGraphQLQuery } from 'json-to-graphql-query'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  return response?.data?.data?.findEntity?.terminalDetails !== null
    ? response?.data?.data?.findEntity?.terminalDetails
    : response?.data?.errors?.[0]?.exception?.emsErrorCodeDetailsDto?.channelDesc ??
        response?.data?.errors?.[0]?.exception?.message ??
        response?.data?.errors?.[0]?.message
}

const getTerminalListDetailsBody = (searchString: string) => {
  const queryObj = {
    findEntity: {
      __args: {
        entityId: searchString,
      },
      terminalDetails: {
        terminalId: true,
        mid: true,
        deviceSerialNo: true,
        terminalType: true,
        mobileNumber: true,
        nickName: true,
        status: true,
        terminalConfigurationDetails: {
          key: true,
          value: true,
        },
        device: {
          deviceSerialNo: true,
          deviceStatus: true,
        },
      },
    },
  }

  const query = `{${jsonToGraphQLQuery(queryObj, { pretty: false })}}`
  console.log('fetchEntityDetailsGetMerchantReq query: ', query)
  return query
}

const fetchTerminalListDetailsReq = (searchString: string, tokens: any) => {
  const { REACT_APP_ENV } = window?._env_
  const request: JFSRequest<{}> = {
    apiPath:
      REACT_APP_ENV === 'pp' || REACT_APP_ENV === 'prod'
        ? APIEndPoints.searchEntityPPV2
        : getUrl(APIEndPoints.searchEntity),
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: getTerminalListDetailsBody(searchString),
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { fetchTerminalListDetailsReq }
